import React from "react";
// import Wall from "../../assets/images/Wall.svg";
// import Code from "../../assets/images/code.svg";
import { useTranslation } from "react-i18next";
const NoScenario = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <div className="text-right position-relative" style={{ top: "50px" }}>
        <img src={Wall} />
      </div> */}
      {/* <div
        className="position-relative"
        style={{ top: "-20px", left: "-26px" }}
      >
        <img src={Code} />
      </div> */}
      {/* <div
        className="text-right muted fn position-absolute"
        style={{ bottom: "187px", width: "45%" }}
      >
        <p>
          {t(
            "شما میتوانید سناریو های مختلفی برای راحت شدن کار ها اضافه کنید !"
          )}
        </p>
      </div> */}
    </>
  );
};

export { NoScenario };
